import React, { Suspense } from "react";
import { Form, Col } from "react-bootstrap";
import { Highlighter, Typeahead } from "react-bootstrap-typeahead";
import { Await, useLoaderData, useNavigate } from "react-router-dom";
import moment from "moment/min/moment-with-locales";
import { formatDaypartText } from "../HelperFunctions";

export default function DaypartPicker({ formData, setFormData, name, filterFunction = () => true }) {
    const { dayparts } = useLoaderData();
    const navigate = useNavigate();

    function handleDaypartChange(value) {
        if (value.length) {
            if (value[0].id === -1) {
                navigate("/settings/dayparts");
            } else {
                setFormData(current => ({
                    ...current,
                    daypart: value,
                    days: value[0].weekdays,
                    timeRange: [value[0].start_time, value[0].end_time],
                    hourRange: [moment(value[0].start_time, "HH:mm:ss").hour(), moment(value[0].end_time, "HH:mm:ss").hour() + 1 || 24],
                }));
            }
        } else {
            setFormData(current => ({ ...current, daypart: value }));
        }
    }

    return (
        <Suspense fallback={<Fallback name={name} />}>
            <Await resolve={dayparts}>
                {resolvedDayparts => (
                    <Form.Group as={Col} className="col-12 col-xl-2 min-w-user-daypart">
                        <Form.Label>Daypart</Form.Label>
                        <Typeahead
                            id={`${name}-daypart-selection`}
                            options={resolvedDayparts.data
                                .filter(x => x.radio_id === formData.station[0]?.radio_id)
                                .filter(filterFunction)
                                .sort(
                                    (a, b) =>
                                        a.weekdays[0] - b.weekdays[0] ||
                                        b.weekdays[b.weekdays.length - 1] - a.weekdays[a.weekdays.length - 1] ||
                                        a.start_time.localeCompare(b.start_time) ||
                                        a.end_time.localeCompare(b.end_time)
                                )
                                .concat([{ id: -1, name: "Add/Edit Dayparts" }])}
                            labelKey={x => x.name ?? formatDaypartText(x)}
                            highlightOnlyResult
                            placeholder="Select daypart..."
                            clearButton={true}
                            renderMenuItemChildren={(option, { text }) => (
                                <>
                                    <Highlighter search={text}>{option.name ?? formatDaypartText(option)}</Highlighter>
                                    <div>
                                        {option.id === -1 ? (
                                            <small className=" text-secondary">Jump to settings</small>
                                        ) : (
                                            <small className=" text-secondary">{formatDaypartText(option)}</small>
                                        )}
                                    </div>
                                </>
                            )}
                            onChange={handleDaypartChange}
                            disabled={!formData.station.length}
                            selected={formData.daypart}
                        />
                    </Form.Group>
                )}
            </Await>
        </Suspense>
    );
}

function Fallback({ name }) {
    return (
        <Form.Group as={Col} className="col-12 col-xl-2 min-w-user-daypart">
            <Form.Label>Daypart</Form.Label>
            <Typeahead id={`${name}-daypart-selection-fallback`} options={[]} placeholder="Loading dayparts..." disabled />
        </Form.Group>
    );
}
